"use client"

import { useState } from "react"
import { NpEmailSignupSuccess } from "src/components/np-design/sections/newsletter/NpEmailSignupSuccess"
import { BackInStockSignupForm } from "src/components/product-details/buyBox/backInStock/BackInStockSignupForm"

export type BackInStockSubcriptionButtonProps = {
  sku: string
}

export const BackInStockSubcriptionButton = ({ sku }: BackInStockSubcriptionButtonProps) => {
  const [success, setSuccess] = useState(false)

  if (success) {
    return <NpEmailSignupSuccess />
  }

  return <BackInStockSignupForm sku={sku} onSuccess={() => setSuccess(true)} />
}
